import { createRouter, createWebHistory } from 'vue-router'


const routes = [

    {
      path: "/",
      name: "home",
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/',
          name: 'home',
          component: () => import("../components/pages/Home.vue"),
        }
      ]
    },
    {
      path: "/about",
      name: "about",
      meta:{
        text: 'About Conference',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/about',
          name: 'about',
          text: 'About Us',
          component: () => import("../components/pages/About.vue"),
        }
      ]
    },
    {
      path: "/speakers",
      name: "speakers",
      meta:{
        text: 'Speakers',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/speakers',
          name: 'speakers',
          component: () => import("../components/pages/Speakers.vue"),
        }
      ]
    },
    {
      path: "/schedules",
      name: "Schedules",
      meta:{
        text: 'Conference Schedules',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/schedules',
          name: 'Schedules',
          component: () => import("../components/pages/Schedules.vue"),
        }
      ]
    },

    {
      path: "/schedules-detail-day1",
      name: "schedules-detail-day1",
      meta:{
        text: 'Inauguration and Localization Workshop',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/schedules-detail-day1',
          name: 'SchedulesDayOne',
          component: () => import("../components/pages/SchedulesDayOne.vue"),
        }
      ]
    },

    {
      path: "/schedules-detail-day2",
      name: "schedulesdetailday2",
      meta:{
        text: 'ASF Annual Conference Day',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/schedules-detail-day2',
          name: 'SchedulesDayTwo',
          component: () => import("../components/pages/SchedulesDayTwo.vue"),
        }
      ]
    },

    {
      path: "/schedules-detail-day3",
      name: "schedulesdetailday3",
      meta:{
        text: 'Field visit day (November 30, 2022)',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/schedules-detail-day3',
          name: 'SchedulesDayThree',
          component: () => import("../components/pages/SchedulesDayThree.vue"),
        }
      ]
    },

    {
      path: "/gallery",
      name: "gallery",
      meta:{
        text: 'Gallery',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/gallery',
          name: 'gallery',
          component: () => import("../components/pages/Gallery.vue"),
        }
      ]
    },
    {
      path: "/videos",
      name: "videos",
      meta:{
        text: 'Videos',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/videos',
          name: 'videos',
          component: () => import("../components/pages/VideoGallery.vue"),
        }
      ]
    },
    {
      path: "/marketplace",
      name: "marketplace",
      meta:{
        text: 'Marketplace',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/marketplace',
          name: 'marketplace',
          component: () => import("../components/pages/Marketplace.vue"),
        }
      ]
    },
    {
      path: "/contact",
      name: "contact",
      meta:{
        text: 'Contact Us',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/contact',
          name: 'contact',
          component: () => import("../components/pages/Contact.vue"),
        }
      ]
    },
    {
      path: "/registration",
      name: "registration",
      meta:{
        text: 'Registraton',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/registration',
          name: 'registration',
          component: () => import("../components/pages/Registration.vue"),
        }
      ]
    }, 
    {
      path: "/registration-terms-and-condition",
      name: "registration-terms-and-condition",
      meta:{
        text: 'Terms & Conditions',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/registration-terms-and-condition',
          name: 'registration-terms-and-condition',
          component: () => import("../components/pages/TermsAndConditions.vue"),
        }
      ]
    },
    {
      path: "/registration-terms-and-condition-virtual",
      name: "registration-terms-and-condition-virtual",
      meta:{
        text: 'Terms & Conditions',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/registration-terms-and-condition-virtual',
          name: 'registration-terms-and-condition-virtual',
          component: () => import("../components/pages/TermsAndConditionsForVirtual.vue"),
        }
      ]
    },
    {
      path: "/reports",
      name: "reports",
      meta:{
        text: 'Reports',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/reports',
          name: 'reports',
          component: () => import("../components/pages/Reports.vue"),
        }
      ]
    },  
    {
      path: "/documents",
      name: "documents",
      meta:{
        text: 'Documents',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/documents',
          name: 'documents',
          component: () => import("../components/pages/Documents.vue"),
        }
      ]
    },    
    { 
      path: '/:pathMatch(.*)*', 
      component: () => import('../components/pages/404.vue'),
    },

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  
});


router.beforeEach((to, from, next) => {
  //console.log(`Navigating to: ${to.name}`);
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });
  next();
});
export default router;
